var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { TabItemStyled, TabWrapperStyled } from './styled';
const Tabs = (_a) => {
    var props = __rest(_a, []);
    const { tabs, currentTab: currentTabProp, onChange, itemStyle, size } = props, rest = __rest(props, ["tabs", "currentTab", "onChange", "itemStyle", "size"]);
    const [currentTab, setCurrentTab] = useState(currentTabProp);
    const handleClick = (value) => {
        setCurrentTab(value);
    };
    return (_jsx(TabWrapperStyled, Object.assign({ size: size, tabs: tabs }, rest, { children: tabs.map((tabItem, index) => {
            const { value, label } = tabItem;
            const defaultLabel = label || value || '';
            return (_jsx(TabItemStyled, Object.assign({ currentTab: currentTab, label: defaultLabel, name: defaultLabel, size: size, style: itemStyle, onClick: (e) => {
                    if (defaultLabel === currentTab)
                        return;
                    onChange(e);
                    handleClick(defaultLabel);
                } }, tabItem, { children: defaultLabel }), `${defaultLabel}-${index}`));
        }) })));
};
export default Tabs;
//# sourceMappingURL=index.js.map